<template>
  <div>
    <TitleH1 :title="title" />
    <ReportsTabs
      v-if="tabs.length"
      :class="[
        'material-zgi-tabs',
        { 'tab--single': tabs.length === 1 },
        { 'tab--some': tabs.length === 2 },
        'tab--new-order',
      ]"
      :tabs="tabs"
    >
      <PageContent
        v-show="$route.query.tab === 'from_dealers'"
        :systemOptions="systemOptions"
        :subDealerOptions="subDealerOptions"
        :statusOptions="statusOptions"
      />
      <PageContent
        v-show="isTabToSupplier && $route.query.tab === 'to_supplier'"
        :systemOptions="systemOptions"
        :subDealerOptions="subDealerOptions"
        :statusOptions="statusOptions"
      />
      <PageContent
        v-show="$route.query.tab === 'retail'"
        :systemOptions="systemOptions"
        :subDealerOptions="subDealerOptions"
        :statusOptions="statusOptions"
      />
    </ReportsTabs>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { api } from '@/api';

export default {
  name: 'MaterialsZgi',
  components: {
    TitleH1: () => import('@/elements/Meta/TitleH1'),
    ReportsTabs: () => import('@/pages/account/components/ReportsTabs'),
    PageContent: () => import('./components/PageContent/PageContent'),
  },
  metaInfo() {
    return {
      title: `${this.title} - Личный кабинет дилера - ${this.getDealerName}`,
    };
  },
  data: () => ({
    title: 'Отчет по материалам в заказах на готовые изделия',
    tabsDefault: [
      {
        name: 'Розничные заказы',
        path: 'retail',
      },
    ],
    systemOptions: [],
    subDealerOptions: [],
    statusOptions: [],
    subDealerTab: {
      name: 'Заказы от дилеров',
      path: 'from_dealers',
    },
    supplierTab: {
      name: 'Заказы поставщику',
      path: 'to_supplier',
    },
    allSystemItem: { name: 'Все системы', value: null },
    allSubDealer: { name: 'Все дилеры', value: null },
    allStatus: { name: 'Все заказы', value: null },
  }),
  computed: {
    ...mapGetters('user', ['getDealerName', 'getDealer']),
    isTabToSupplier() {
      const dealer = this.getDealer;
      const isValue = Boolean(dealer?.parent_dealer);

      return isValue;
    },

    tabs() {
      const tabsFilter = [
        this.subDealerOptions?.length && this.subDealerTab,
        this.isTabToSupplier && this.supplierTab,
        ...this.tabsDefault,
      ].filter(Boolean);

      return tabsFilter;
    },
  },
  methods: {
    fetchData() {
      this.togglePreload();
      Promise.allSettled([
        api.methods.systems.get(),
        api.methods.dealers.getSubDealers.get(true),
        api.methods.orders.statuses.get(),
      ])
        .then(res => {
          const systems = res[0];
          const subDealers = res[1];
          const statuses = res[2];

          if (subDealers?.value) {
            const list = subDealers.value.data.map(({ id, name }) => ({ name, value: id }));
            if (list?.length > 0) {
              this.subDealerOptions = [this.allSubDealer, ...list];
            }
          } else {
            this.$danger('Не удалось получить список суб дилеров');
          }

          if (systems?.value) {
            const list = systems.value.data.map(({ id, name }) => ({ name, value: id }));
            if (list?.length > 0) {
              this.systemOptions = [this.allSystemItem, ...list];
            }
          } else {
            this.$danger('Не удалось получить системы');
          }

          if (statuses?.value) {
            const list = statuses.value.data.map(item => ({ ...item, value: item.id }));
            if (list?.length > 0) {
              this.statusOptions = [this.allStatus, ...list];
            }
          } else {
            this.$danger('Не удалось получить список статусов заказов');
          }
        })
        .finally(() => {
          this.togglePreload();
        });
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style lang="scss">
.material-zgi-tabs {
  [class~='tab__list'] {
    width: calc(100% - 345px) !important;
  }

  [class~='tab__content'] {
    overflow-y: initial !important;
  }
}
</style>

<style lang="scss" scoped>
.title {
  white-space: pre;

  @media (max-width: $desktop) {
    white-space: normal;
  }
}
</style>
